<template>
    <div>
        <el-dialog :visible="listDialogVisible" width="1300px" :before-close="handleClose" :show-close="false"
            :append-to-body="true" class="warning-dialog">
            <div class="warning-root">
                <span class="deco-bar"></span>
                <div class="title-pill">
                    <span class="title-pill-text">预警列表</span>
                </div>
                <div class="content-stack">
                    <div class="stats-row">
                        <div class="stat-card stat-card-level">
                            <div class="stat-grid stat-grid-3">
                                <div class="stat-cell" :class="{ active: selectedLevel === 1 }"
                                    @click="handleLevelChange(1)">
                                    <div class="stat-name-row stat-name-primary">
                                        <span class="stat-dot dot-primary"></span>
                                        <span class="stat-label">初级</span>
                                    </div>
                                    <div class="stat-count-row stat-count-primary">
                                        <span class="stat-count">{{ levelCount[1] }}</span>
                                        <span class="stat-unit">个</span>
                                    </div>
                                    <span class="active-check" aria-hidden="true">
                                        <svg viewBox="0 0 12 9" width="10" height="8">
                                            <path d="M1 4.5l3 3 7-7" fill="none" stroke="#fff" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                </div>
                                <div class="stat-cell" :class="{ active: selectedLevel === 2 }"
                                    @click="handleLevelChange(2)">
                                    <div class="stat-name-row stat-name-mid">
                                        <span class="stat-dot dot-mid"></span>
                                        <span class="stat-label">中级</span>
                                    </div>
                                    <div class="stat-count-row stat-count-mid">
                                        <span class="stat-count">{{ levelCount[2] }}</span>
                                        <span class="stat-unit">个</span>
                                    </div>
                                    <span class="active-check" aria-hidden="true">
                                        <svg viewBox="0 0 12 9" width="10" height="8">
                                            <path d="M1 4.5l3 3 7-7" fill="none" stroke="#fff" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                </div>
                                <div class="stat-cell" :class="{ active: selectedLevel === 3 }"
                                    @click="handleLevelChange(3)">
                                    <div class="stat-name-row stat-name-high">
                                        <span class="stat-dot dot-high"></span>
                                        <span class="stat-label">高级</span>
                                    </div>
                                    <div class="stat-count-row stat-count-high">
                                        <span class="stat-count">{{ levelCount[3] }}</span>
                                        <span class="stat-unit">个</span>
                                    </div>
                                    <span class="active-check" aria-hidden="true">
                                        <svg viewBox="0 0 12 9" width="10" height="8">
                                            <path d="M1 4.5l3 3 7-7" fill="none" stroke="#fff" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="stat-card stat-card-status">
                            <div class="stat-grid stat-grid-2">
                                <div class="stat-cell" :class="{ active: selectedStatus === 1 }"
                                    @click="handleStatusChange(1)">
                                    <div class="stat-name-row stat-name-pending">
                                        <span class="stat-dot dot-pending"></span>
                                        <span class="stat-label">未处理</span>
                                    </div>
                                    <div class="stat-count-row stat-count-pending">
                                        <span class="stat-count">{{ statusCount[1] }}</span>
                                        <span class="stat-unit">个</span>
                                    </div>
                                    <span class="active-check" aria-hidden="true">
                                        <svg viewBox="0 0 12 9" width="10" height="8">
                                            <path d="M1 4.5l3 3 7-7" fill="none" stroke="#fff" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                </div>
                                <div class="stat-cell" :class="{ active: selectedStatus === 2 }"
                                    @click="handleStatusChange(2)">
                                    <div class="stat-name-row stat-name-processed">
                                        <span class="stat-dot dot-processed"></span>
                                        <span class="stat-label">已处理</span>
                                    </div>
                                    <div class="stat-count-row stat-count-processed">
                                        <span class="stat-count">{{ statusCount[2] }}</span>
                                        <span class="stat-unit">个</span>
                                    </div>
                                    <span class="active-check" aria-hidden="true">
                                        <svg viewBox="0 0 12 9" width="10" height="8">
                                            <path d="M1 4.5l3 3 7-7" fill="none" stroke="#fff" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="warning-grid" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                        <div class="warning-card" v-for="item in warningList" :key="item.id" @click="openDetail(item)">
                            <div class="card-header">
                                <div class="card-header-left">
                                    <div class="card-title-row">
                                        <span class="level-pill" :class="'level-' + item.level">
                                            {{ getLevelName(item.level) }}
                                        </span>
                                        <span class="warning-title">{{ item.warningNames || "-" }}</span>
                                    </div>
                                    <div class="card-location-row">
                                        <svg class="location-icon" viewBox="0 0 9 12" aria-hidden="true">
                                            <path
                                                d="M4.5 0C2.01 0 0 1.93 0 4.31c0 3.24 4.5 7.69 4.5 7.69s4.5-4.45 4.5-7.69C9 1.93 6.99 0 4.5 0zm0 5.86a1.55 1.55 0 1 1 0-3.1 1.55 1.55 0 0 1 0 3.1z"
                                                fill="currentColor" />
                                        </svg>
                                        <el-tooltip :content="buildLocation(item)" placement="top"
                                            effect="dark">
                                            <span class="location-text">
                                                {{ buildLocation(item) }}
                                            </span>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <div class="card-header-right" :class="getStatusClass(item)">
                                    <span class="status-dot"></span>
                                    <span class="status-label">{{ getStatusName(item) }}</span>
                                </div>
                            </div>

                            <div class="card-footer">
                                <div class="handler-line">处理人：{{ buildHandler(item) }}</div>
                                <div class="warn-time-line">预警时间&nbsp;&nbsp;{{ formatTime(item.warningTime) }}</div>
                            </div>
                        </div>

                        <div class="empty-data" v-if="!loading && warningList.length === 0">
                            <span>暂无数据</span>
                        </div>
                    </div>

                    <div class="pagination-row">
                        <button class="page-arrow" :disabled="pageNo <= 1" @click="handlePageChange(pageNo - 1)"
                            aria-label="上一页">
                            <svg viewBox="0 0 26 26" aria-hidden="true">
                                <path d="M16.5 5l-7 8 7 8" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                        <button v-for="p in pageNumbers" :key="p.key" class="page-num"
                            :class="{ active: p.value === pageNo, ellipsis: p.ellipsis }" :disabled="p.ellipsis"
                            @click="!p.ellipsis && handlePageChange(p.value)">
                            {{ p.label }}
                        </button>
                        <button class="page-arrow" :disabled="pageNo >= totalPages"
                            @click="handlePageChange(pageNo + 1)" aria-label="下一页">
                            <svg viewBox="0 0 26 26" aria-hidden="true">
                                <path d="M9.5 5l7 8-7 8" fill="none" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>

                <i class="el-icon-close root-close-btn" @click="handleClose"></i>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="detailVisible" width="65%" :show-close="false" :append-to-body="true"
            class="warning-detail-dialog" @close="handleDetailClose">
            <div class="detail-root" v-loading="detailLoading" element-loading-background="rgba(0, 0, 0, 0.8)">
                <i class="el-icon-close root-close-btn" @click="handleDetailClose"></i>

                <div class="title-pill detail-title-pill">
                    <span class="title-pill-text">预警详情</span>
                </div>

                <div class="detail-header">
                    <div class="detail-card detail-card-left">
                        <div class="detail-project">
                            <div class="detail-project-img">
                                <!-- <i class="el-icon-office-building"></i> -->
                                <img src="../../assets/image 60.png" alt="">
                            </div>
                            <div class="detail-project-name">{{ currentDetail.warningTitle || "-" }}</div>
                        </div>
                        <span class="level-pill" :class="'level-' + currentDetail.level">
                            {{ getLevelName(currentDetail.level) }}
                        </span>
                    </div>

                    <div class=" detail-card-middle">
                        <div class="detail-time">{{ currentDetail.warningTime || "-" }}</div>
                        <div class="detail-timeline">
                            <img class="timeline-line" src="../../assets/Group 35.svg" alt="" />
                            <span class="timeline-node" style="transform: rotate(180deg);margin-bottom: 12px;">
                                <svg width="24" height="48" viewBox="0 0 35.0031 59.0001" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#shadowLeft)">
                                        <path d="M5.50007 17.5C8.29914 19.652 12.4044 25.8649 6.4331 33.5"
                                            stroke="#D0D1D9" stroke-width="3" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M11.5001 9.5C16.5815 15.0273 23.8713 29.1655 12.3795 41.5"
                                            stroke="#D0D1D9" stroke-width="3" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M20.5001 1.5C27.2917 8.38485 36.7999 27.6236 20.5001 49.5"
                                            stroke="#00F6BE" stroke-width="3" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <filter id="shadowLeft" x="0" y="0" width="35.0031" height="59.0001"
                                            filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset dy="4" />
                                            <feGaussianBlur stdDeviation="2" />
                                            <feComposite in2="hardAlpha" operator="out" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0.522426 0 0 0 0 0.792663 0 0 0 0 0.98569 0 0 0 0.25 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix"
                                                result="effect1_dropShadow_0_11" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_11"
                                                result="shape" />
                                        </filter>
                                    </defs>
                                </svg>
                            </span>
                            <span class="timeline-img">
                                <img v-if="currentDetail.warningImage" :src="currentDetail.warningImage" alt="" />
                                <img v-else src="@/assets/timeImg.png" alt="" />
                            </span>
                            <span class="timeline-node">
                                <svg width="24" height="48" viewBox="0 0 35.0031 59.0001" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#shadowRight)">
                                        <path d="M5.50007 17.5C8.29914 19.652 12.4044 25.8649 6.4331 33.5"
                                            stroke="#D0D1D9" stroke-width="3" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M11.5001 9.5C16.5815 15.0273 23.8713 29.1655 12.3795 41.5"
                                            stroke="#D0D1D9" stroke-width="3" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M20.5001 1.5C27.2917 8.38485 36.7999 27.6236 20.5001 49.5"
                                            stroke="#00F6BE" stroke-width="3" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <filter id="shadowRight" x="0" y="0" width="35.0031" height="59.0001"
                                            filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset dy="4" />
                                            <feGaussianBlur stdDeviation="2" />
                                            <feComposite in2="hardAlpha" operator="out" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0.522426 0 0 0 0 0.792663 0 0 0 0 0.98569 0 0 0 0.25 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix"
                                                result="effect1_dropShadow_0_11" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_11"
                                                result="shape" />
                                        </filter>
                                    </defs>
                                </svg>
                            </span>
                            <img class="timeline-line" src="../../assets/Group 35.svg" alt="" />
                        </div>
                        <div class="detail-status">
                            <span class="status-dot">
                                <svg v-if="isWarningProcessed(currentDetail)" width="16" height="16" viewBox="0 0 16 16" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="8" cy="8" r="8" fill="#00FF11" />
                                    <path d="M4 8L7.5 10.5L12.5 5" stroke="black" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <svg v-else width="16" height="16" viewBox="0 0 16 16" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="8" cy="8" r="8" fill="#FB6867" />
                                    <path d="M5.5 5.5L10.5 10.5M10.5 5.5L5.5 10.5" stroke="white" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                            <span class="status-label">{{ getStatusName(currentDetail) }}</span>
                        </div>
                    </div>

                    <div class="detail-card detail-card-right">
                        <div class="detail-section-title">
                            <span class="section-bar"></span>
                            <span style="line-height: normal;">预警接受人</span>
                        </div>
                        <div class="handler-list">
                            <div class="handler-row" v-if="currentDetail.warningReceiveNames && currentDetail.warningReceiveNames.length">
                                <div class="handler-cell" v-for="(name, idx) in currentDetail.warningReceiveNames" :key="idx">
                                    <span class="handler-avatar"><img src="@/assets/avatar.png" alt="" /></span>
                                    <span class="handler-name">{{ name }}</span>
                                </div>
                            </div>
                            <div class="handler-row" v-else>
                                <span style="color:#8aa4c4;font-size:13px;">暂无接受人信息</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="detail-section detail-section-handle">
                    <div class="detail-section-title">
                        <span class="section-bar"></span>
                        <span>处理内容</span>
                    </div>
                    <div class="detail-handle-body">
                        <div class="detail-handle-col">
                            <div class="detail-handle-row">
                                <span class="handle-label">处理单位</span>
                                <span
                                    class="handle-value handle-value-ellipsis"
                                    :title="currentDetail.userOfficeNames || '-'"
                                >{{ currentDetail.userOfficeNames || "-" }}</span>
                            </div>
                            <div class="detail-handle-row">
                                <span class="handle-label">处理人</span>
                                <span class="handle-value">{{ currentDetail.userName || "-" }}</span>
                            </div>
                            <div class="detail-handle-row">
                                <span class="handle-label">处理时间</span>
                                <span class="handle-value">{{ currentDetail.processTime || "-" }}</span>
                            </div>
                            <div class="detail-handle-row">
                                <span class="handle-label">处理方案</span>
                                <span class="handle-value">{{ currentDetail.solution || "-" }}</span>
                            </div>
                        </div>
                        <div class="detail-handle-col detail-handle-img-col">
                            <div class="detail-handle-row">
                                <span class="handle-label">处理图片</span>
                            </div>
                            <div class="img-placeholder" v-if="!currentDetail.pictureUrlList || currentDetail.pictureUrlList.length === 0">
                                <span class="img-placeholder-text">暂无图片</span>
                            </div>
                            <div class="img-list" v-else>
                                <img v-for="(url, idx) in currentDetail.pictureUrlList" :key="idx" :src="url" class="handle-img" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="detail-section detail-section-warning">
                    <div class="detail-section-title">
                        <span class="section-bar"></span>
                        <span>预警内容</span>
                    </div>
                    <div class="detail-warning-body">
                        <div class="warning-dot">
                            <span class="warning-dot-inner"></span>
                        </div>
                        <div class="warning-content">
                            <template v-if="currentDetail.warningDetailBox && currentDetail.warningDetailBox.length">
                                <div v-for="(item, idx) in currentDetail.warningDetailBox" :key="idx">
                                    <div class="warning-time-text">出料时间：{{ item.warningTime || "-" }}</div>
                                    <div class="warning-text-card">
                                        <span class="warning-text" v-for="(c, ci) in item.contents" :key="ci">{{ c }}</span>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="warning-time-text">出料时间：{{ currentDetail.warningTime || "-" }}</div>
                                <div class="warning-text-card">
                                    <span class="warning-text">{{ currentDetail.warningContent || "-" }}</span>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapState } from "vuex";
import { getWarningPeriodSummary, getWarningPageList, getWarningDetail } from "@/api/api";

export default {
    name: "WarningDialog",
    props: {
        visible: { type: Boolean, default: false },
        type: { type: String, default: "" },
        moduleType: { type: String, default: "mixplant" },
    },
    data() {
        return {
            dialogVisible: false,
            loading: false,
            allWarningList: [], // 接口返回的全部数据（前端分页）
            warningList: [], // 当前页展示数据
            pageNo: 1,
            pageSize: 6,
            totalCount: 0,
            selectedLevel: null,
            selectedStatus: null,
            levelCount: { 1: 0, 2: 0, 3: 0 },
            statusCount: { 1: 0, 2: 0 },
            detailVisible: false,
            currentDetail: {},
            detailLoading: false,
        };
    },
    computed: {
        ...mapState(["engineerId", "sectionId", "workAreaId", "seIds"]),
        listDialogVisible() {
            return this.dialogVisible && !this.detailVisible;
        },
        totalPages() {
            return Math.max(1, Math.ceil(this.totalCount / this.pageSize));
        },
        pageNumbers() {
            const total = this.totalPages;
            const current = this.pageNo;
            if (total <= 5) {
                return Array.from({ length: total }, (_, i) => ({
                    key: `p${i + 1}`,
                    value: i + 1,
                    label: String(i + 1),
                    ellipsis: false,
                }));
            }
            const result = [];
            result.push({ key: "p1", value: 1, label: "1", ellipsis: false });
            if (current > 3) {
                result.push({ key: "eL", value: 0, label: "···", ellipsis: true });
            }
            const start = Math.max(2, current - 1);
            const end = Math.min(total - 1, current + 1);
            for (let i = start; i <= end; i += 1) {
                result.push({ key: `p${i}`, value: i, label: String(i), ellipsis: false });
            }
            if (current < total - 2) {
                result.push({ key: "eR", value: 0, label: "···", ellipsis: true });
            }
            result.push({ key: `p${total}`, value: total, label: String(total), ellipsis: false });
            return result;
        },
        // 构建公共请求参数
        commonParams() {
            const now = new Date();
            const y = now.getFullYear();
            const m = String(now.getMonth() + 1).padStart(2, "0");
            const d = String(now.getDate()).padStart(2, "0");
            const today = `${y}-${m}-${d}`;
            return {
                materialType: this.type,
                // moduleType: this.moduleType,
                engineerId: this.engineerId,
                sectionId: this.workAreaId,
                // workAreaId: this.workAreaId,
                endDate: today,
                startDate: today,
                _t: Date.now(),
            };
        },
    },
    watch: {
        visible(val) {
            this.dialogVisible = val;
            if (val) {
                this.pageNo = 1;
                this.selectedLevel = null;
                this.selectedStatus = null;
                this.fetchPeriodSummary();
                this.fetchWarningList();
            }
        },
        dialogVisible(val) {
            this.$emit("update:visible", val);
        },
    },
    methods: {
        handleClose() {
            this.detailVisible = false;
            this.dialogVisible = false;
            this.$emit("update:visible", false);
        },
        syncStatusCountFromList(list) {
            let pending = 0;
            let processed = 0;
            (list || []).forEach((item) => {
                if (this.isWarningProcessed(item)) {
                    processed += 1;
                } else {
                    pending += 1;
                }
            });
            this.statusCount = { 1: pending, 2: processed };
        },
        // 获取汇总统计数据（等级）
        async fetchPeriodSummary() {
            try {
                const res = await getWarningPeriodSummary(this.commonParams);
                const data = res && res.data ? res.data : {};
                this.levelCount = {
                    1: data.mildCount || 0,
                    2: data.moderateCount || 0,
                    3: data.seriousCount || 0,
                };
            } catch (error) {
                console.error("获取预警汇总统计失败:", error);
            }
        },
        buildWarningListParams() {
            const params = Object.assign({}, this.commonParams, {
                pageSize: 1000,
                pageNo: 1,
            });
            // selectedStatus: 1=未处理, 2=已处理；统计时 0、1 均归为未处理
            if (this.selectedStatus === 1) {
                params.warningType = '0,1';
            } else if (this.selectedStatus === 2) {
                params.warningType = 2;
            }
            return params;
        },
        // 获取预警列表（按状态传 warningType，等级仍前端筛选+分页）
        async fetchWarningList() {
            this.loading = true;
            try {
                const params = this.buildWarningListParams();
                const res = await getWarningPageList(params);
                console.log(res)
                this.allWarningList = res.data && res.data.list || [];

                // 未筛选状态时，按列表逐条统计（0、1 归为未处理，2 为已处理）
                if (this.selectedStatus === null) {
                    this.syncStatusCountFromList(this.allWarningList);
                }

                // 前端筛选
                let filteredData = this.allWarningList;
                if (this.selectedLevel !== null) {
                    filteredData = filteredData.filter(
                        (item) => item.level === this.selectedLevel
                    );
                }
                if (this.selectedStatus !== null) {
                    // 接口 warningStatus/status: 0、1=未处理，2=已处理
                    // 前端 selectedStatus: 1=未处理, 2=已处理
                    if (this.selectedStatus === 1) {
                        filteredData = filteredData.filter(
                            (item) => !this.isWarningProcessed(item)
                        );
                    } else {
                        filteredData = filteredData.filter(
                            (item) => this.isWarningProcessed(item)
                        );
                    }
                }

                // 前端分页
                this.totalCount = filteredData.length;
                const start = (this.pageNo - 1) * this.pageSize;
                const end = start + this.pageSize;
                this.warningList = filteredData.slice(start, end);
            } catch (error) {
                console.error("获取预警列表失败:", error);
                this.$message.error("获取预警列表失败");
                this.warningList = [];
                this.allWarningList = [];
                this.totalCount = 0;
            } finally {
                this.loading = false;
            }
        },
        // 打开预警详情
        async openDetail(item) {
            this.detailLoading = true;
            this.detailVisible = true;
            try {
                const res = await getWarningDetail({
                    id: item.id,
                    moduleType: this.moduleType,
                });
                const data = res && res.data ? res.data : {};
                // 对齐 information.vue 数据处理逻辑
                const warningReceiveNames = data.warningReceiveNames
                    ? data.warningReceiveNames.split(',').filter(Boolean)
                    : [];
                const pictureUrlList = this.parseAccessorys(data.pictureUrl);
                const processPerson = data.processPerson || data.warningReceiveNames || '';
                const processTime = data.processTime || '';
                const solution = data.solution || '';
                const warningDetailBox = data.warningDetailBox || [];
                const warningContent = data.warningContent || '';
                this.currentDetail = Object.assign({}, data, {
                    warningReceiveNames,
                    pictureUrlList,
                    processPerson,
                    processTime,
                    solution,
                    warningDetailBox,
                    warningContent,
                });
            } catch (error) {
                console.error("获取预警详情失败:", error);
                this.$message.error("获取预警详情失败");
                this.currentDetail = {};
            } finally {
                this.detailLoading = false;
            }
        },
        // 解析附件字段，兼容多种返回格式（对齐 information.vue）
        parseAccessorys(data) {
            if (!data) return [];
            if (Array.isArray(data)) {
                return data.map(item => {
                    if (typeof item === 'string') return item;
                    if (item && item.url) return item.url;
                    return '';
                }).filter(Boolean);
            }
            if (typeof data === 'string') {
                try {
                    const parsed = JSON.parse(data);
                    if (Array.isArray(parsed)) {
                        return parsed.map(item => {
                            if (typeof item === 'string') return item;
                            if (item && item.url) return item.url;
                            return '';
                        }).filter(Boolean);
                    }
                } catch (e) {
                    return data.split(',').map(s => s.trim()).filter(Boolean);
                }
            }
            return [];
        },
        handleDetailClose() {
            this.detailVisible = false;
            this.currentDetail = {};
        },
        handleLevelChange(level) {
            this.selectedLevel = this.selectedLevel === level ? null : level;
            this.pageNo = 1;
            this.fetchWarningList();
        },
        handleStatusChange(status) {
            this.selectedStatus = this.selectedStatus === status ? null : status;
            this.pageNo = 1;
            this.fetchWarningList();
        },
        handlePageChange(page) {
            if (page < 1 || page > this.totalPages) return;
            this.pageNo = page;
            // 前端分页，直接从已拉取的数据中切片
            const filteredData = this.getFilteredData();
            this.totalCount = filteredData.length;
            const start = (this.pageNo - 1) * this.pageSize;
            const end = start + this.pageSize;
            this.warningList = filteredData.slice(start, end);
        },
        // 获取筛选后的全部数据（复用逻辑）
        getFilteredData() {
            let filteredData = this.allWarningList;
            if (this.selectedLevel !== null) {
                filteredData = filteredData.filter(
                    (item) => item.level === this.selectedLevel
                );
            }
            if (this.selectedStatus !== null) {
                if (this.selectedStatus === 1) {
                    filteredData = filteredData.filter(
                        (item) => !this.isWarningProcessed(item)
                    );
                } else {
                    filteredData = filteredData.filter(
                        (item) => this.isWarningProcessed(item)
                    );
                }
            }
            return filteredData;
        },
        formatTime(timeStr) {
            if (!timeStr) return "-";
            return timeStr.substring(5, 16).replace("-", "/");
        },
        buildLocation(item) {
            const engineeringName = (item.engineering && item.engineering.engineeringName) || '';
            const sectionName = (item.section && item.section.sectionName) || '';
            const workareaName = (item.workarea && item.workarea.name) || '';
            const plantName = (item.batchingPlant && item.batchingPlant.name) || '';
            const parts = [engineeringName + sectionName, workareaName, plantName].filter(Boolean);
            return parts.length ? parts.join('+') : '-';
        },
        buildHandler(item) {
            if (item.handlerUnit && item.handler) {
                return `${item.handlerUnit} - ${item.handler}`;
            }
            return item.userName || item.userName || '暂无';
        },
        getLevelName(level) {
            const levelMap = { 1: "初级", 2: "中级", 3: "高级" };
            return levelMap[level] || "-";
        },
        isWarningProcessed(source) {
            if (source == null) return false;
            if (typeof source === 'object') {
                const ws = source.warningStatus;
                const st = source.status;
                return ws == 2 || st == 2;
            }
            return source == 2;
        },
        getStatusName(source) {
            return this.isWarningProcessed(source) ? '已处理' : '未处理';
        },
        getStatusClass(source) {
            return this.isWarningProcessed(source) ? 'status-1' : 'status-0';
        },
    },
};
</script>
<style lang="less" scoped>
/* 主弹框根容器 */
.warning-dialog {
    /deep/ .el-dialog {
        background: transparent;
        box-shadow: none;
        border: none;

        .el-dialog__header {
            padding: 0;
            border-bottom: none;
        }

        .el-dialog__body {
            padding: 0;
            background: transparent;
        }
    }

    /deep/ .v-modal {
        display: none !important;
    }

    /deep/ .el-dialog__wrapper {
        background: transparent !important;
    }

    .warning-root {
        position: relative;
        width: 100%;
        padding: 0 29px 30px;
        background: rgba(9, 23, 71, 0.5);
        backdrop-filter: blur(16px);
        -webkit-backdrop-filter: blur(16px);
        border: 1.5px solid #005994;
        border-radius: 10px;
        box-shadow: inset 0 0 10px 0 #60aaff;
        box-sizing: border-box;
    }

    .deco-bar {
        position: absolute;
        left: 20px;
        top: 280px;
        width: 8px;
        height: 143px;
        border-radius: 100px;
        background: #23518a;
        pointer-events: none;
    }



    .content-stack {
        display: flex;
        flex-direction: column;
        gap: 15px;
        width: 100%;
    }

    .stats-row {
        display: flex;
        gap: 16px;
        width: 100%;
    }

    .stat-card {
        position: relative;
        background: rgba(0, 17, 74, 0.6);
        border: 1.5px solid #005088;
        border-radius: 10px;
        box-shadow: 0 0 6px 0 rgba(21, 126, 206, 0.3);
        padding: 16px 0;
    }

    .stat-card-level {
        flex: 3;
    }

    .stat-card-status {
        flex: 2;
    }

    .stat-grid {
        display: grid;
        height: 60px;
        align-items: center;
    }

    .stat-grid-3 {
        grid-template-columns: 1fr 1fr 1fr;
        padding-left: 50px;
        padding-right: 24px;
        column-gap: 50px;
    }

    .stat-grid-2 {
        grid-template-columns: 1fr 1fr;
        padding: 0 30px;
    }

    .stat-cell {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        // gap: 4px;
        cursor: pointer;
        // height: 100%;
        padding: 6px 16px;
        border-radius: 10px;
        transition: background 0.2s;

        &.active {
            background: rgba(255, 255, 255, 0.08);
        }

        &:not(:last-child)::after {
            content: "";
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 1px;
            height: 22px;
            background: rgba(255, 255, 255, 0.2);
        }
    }

    .stat-cell-highlight {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 10px;
    }

    .stat-grid-2 .stat-cell {
        padding: 6px 30px;
    }

    .stat-name-row {
        display: flex;
        align-items: center;
        gap: 6px;
        line-height: 18px;
    }

    .stat-count-row {
        display: flex;
        align-items: flex-end;
        gap: 4px;
        line-height: 1;
    }

    .stat-dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        flex-shrink: 0;
    }

    .dot-primary {
        background: #2358cb;
        box-shadow: 0 0 4px 0 #2358cb;
    }

    .dot-mid {
        background: #cf911f;
        box-shadow: 0 0 4px 0 #cbc823;
    }

    .dot-high {
        background: #f51f45;
        box-shadow: 0 0 4px 0 #f51f45;
    }

    .dot-pending {
        background: #ffd000;
        box-shadow: 0 0 4px 0 #ffd000;
    }

    .dot-processed {
        background: #1aff1a;
        box-shadow: 0 0 4px 0 #1aff1a;
    }

    .stat-label {
        font-size: 13px;
        font-weight: 500;
        line-height: 18px;
        color: #b8d6fd;
    }

    .stat-name-primary .stat-label {
        color: #1a6fd4;
    }

    .stat-name-mid .stat-label {
        color: #cf911f;
    }

    .stat-name-high .stat-label {
        color: #f51f45;
    }

    .stat-name-pending .stat-label {
        color: #ffd000;
    }

    .stat-name-processed .stat-label {
        color: #1aff1a;
    }

    .stat-count {
        font-size: 24px;
        font-weight: 500;
        line-height: 34px;
        color: #fff;
    }

    .stat-count-primary .stat-count {
        color: #1a6fd4;
    }

    .stat-count-mid .stat-count {
        color: #cf911f;
    }

    .stat-count-high .stat-count {
        color: #f51f45;
    }

    .stat-count-pending .stat-count {
        color: #ffd000;
    }

    .stat-count-processed .stat-count {
        color: #1aff1a;
    }

    .stat-unit {
        font-size: 13px;
        color: #b8d6fd;
        line-height: normal;
        padding-bottom: 4px;
    }

    /* 选中打勾 */
    .active-check {
        position: absolute;
        top: 6px;
        right: 8px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #1aff1a;
        box-shadow: 0 0 4px 0 rgba(26, 255, 26, 0.6);
        display: none;
        align-items: center;
        justify-content: center;
        color: #fff;
    }

    .stat-cell.active .active-check {
        display: inline-flex;
    }

    .active-check svg {
        display: block;
    }

    /* 卡片网格 */
    .warning-grid {
      position: relative;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        column-gap: 16px;
        row-gap: 20px;
        width: 100%;
        min-height: 200px;
        position: relative;
    }

    .warning-card {
        background: rgba(0, 17, 74, 0.6);
        border: 1.5px solid #005088;
        border-radius: 10px;
        box-shadow: 0 0 6px 0 rgba(21, 126, 206, 0.3), inset 0 0 10px 0 rgba(117, 190, 255, 0.4);
        padding: 16px 24px 10px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        cursor: pointer;
        transition: transform 0.2s, box-shadow 0.2s;
        min-width: 0;

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 0 10px 0 rgba(21, 126, 206, 0.5), inset 0 0 10px 0 rgba(117, 190, 255, 0.5);
        }
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 12px;
        min-height: 60px;
        padding-bottom: 10px;
        border-bottom: 1px solid rgba(233, 239, 248, 0.15);
    }

    .card-header-left {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 10px;
        min-width: 0;
    }

    .card-title-row {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
    }



    .warning-title {
        font-size: 18px;
        font-weight: 600;
        line-height: 21px;
        letter-spacing: -0.32px;
        color: #00fbff;
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .card-location-row {
        display: flex;
        align-items: center;
        gap: 6px;
        color: #fff;
    }

    .location-icon {
        width: 9px;
        height: 12px;
        flex-shrink: 0;
        // color: #00fbff;
    }

    .location-text {
        font-size: 13px;
        font-weight: 500;
        color: #fff;
        line-height: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        min-width: 0;
        flex: 1;
    }

    .card-header-right {
        display: flex;
        align-items: center;
        gap: 4px;
        flex-shrink: 0;
        padding-top: 4px;
    }

    .status-dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        flex-shrink: 0;
    }

    .card-header-right.status-1 {
        .status-dot {
            background: #ffd000;
            box-shadow: 0 0 4px 0 #ffd000;
        }

        .status-label {
            color: #ffd000;
        }
    }

    .card-header-right.status-2 {
        .status-dot {
            background: #1aff1a;
            box-shadow: 0 0 4px 0 #1aff1a;
        }

        .status-label {
            color: #1aff1a;
        }
    }

    .card-header-right.status-0 {
        .status-dot {
            background: #ffd000;
            box-shadow: 0 0 4px 0 #ffd000;
        }

        .status-label {
            color: #ffd000;
        }
    }

    .status-label {
        font-size: 13px;
        font-weight: 500;
        line-height: normal;
    }

    .card-footer {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    .handler-line {
        font-size: 13px;
        font-weight: 500;
        color: #fff;
        line-height: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .warn-time-line {
        font-size: 13px;
        color: #ff3256;
        line-height: normal;
        white-space: pre-wrap;
    }

    .empty-data {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
        text-align: center;
        padding: 60px 0;
        color: #8aa4c4;
        font-size: 14px;
    }

    /* 自定义分页 */
    .pagination-row {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 9px;
        padding-top: 8px;
    }

    .page-arrow,
    .page-num {
        width: 26px;
        height: 26px;
        padding: 0;
        border: none;
        border-radius: 4px;
        background: #0d203c;
        color: #98a1af;
        font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition: opacity 0.2s;
    }

    .page-arrow svg {
        width: 12px;
        height: 12px;
    }

    .page-arrow:hover:not(:disabled),
    .page-num:hover:not(:disabled):not(.active) {
        color: #fff;
        background: #14315a;
    }

    .page-arrow:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }

    .page-num.active {
        background: #005cd3;
        color: #fff;
    }

    .page-num.ellipsis {
        background: transparent;
        color: #979dab;
        font-weight: 600;
        cursor: default;
    }


}

.root-close-btn {
    position: absolute;
    right: 20px;
    top: 20px;
    color: #8aa4c4;
    font-size: 20px;
    cursor: pointer;
    z-index: 5;
    transition: color 0.2s;

    &:hover {
        color: #fff;
    }
}

/* 详情弹框 */
.warning-detail-dialog {
    /deep/ .el-dialog {
        background: transparent;
        box-shadow: none;
        border: none;
        margin-top: 5vh !important;
        height: 90vh;
        max-height: 90vh;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .el-dialog__header {
            display: none;
            padding: 0;
            border-bottom: none;
        }

        .el-dialog__body {
            padding: 0;
            background: transparent;
            flex: 1;
            min-height: 0;
            overflow: hidden;
            display: flex;
            flex-direction: column;
        }
    }

    /deep/ .el-dialog__wrapper {
        overflow: hidden;
    }

    /deep/ .v-modal {
        display: none !important;
    }

    /* ==== 弹框根容器 ==== */
    .detail-root {
        position: relative;
        width: 100%;
        height: 100%;
        min-height: 0;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        background: rgba(9, 23, 71, 0.5);
        backdrop-filter: blur(16px);
        -webkit-backdrop-filter: blur(16px);
        border: 1.5px solid #005994;
        border-radius: 10px;
        box-shadow: inset 0 0 10px 0 #60aaff;
        padding: 66px 38px 30px;
        box-sizing: border-box;
    }

    .detail-title-pill {
        position: absolute;
        top: 16px;
        left: 50%;
        transform: translateX(-50%);
        margin: 0;
        width: 280px;
        height: 30px;
    }

    /* ==== 区块一：三栏卡片 ==== */
    .detail-header {
        display: flex;
        flex-direction: row;
        gap: 37px;
        align-items: center;
        width: 100%;
        flex-shrink: 0;
    }

    /* 三栏通用卡片样式 */
    .detail-card {
        position: relative;
        background: rgba(0, 17, 74, 0.6);
        border: 1.5px solid #005088;
        border-radius: 10px;
        box-shadow: 0 0 6px 0 rgba(21, 126, 206, 0.3), inset 0 0 10px 0 rgba(117, 190, 255, 0.4);
    }

    /* 左栏：项目图片 + 项目名 + 级别胶囊 */
    .detail-card-left {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 16px 24px 10px;
        width: 200px;
        flex-shrink: 0;
    }

    .detail-project {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
    }

    .detail-project-img {
        width: 58px;
        height: 61px;
        border-radius: 6px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        i {
            color: #00fbff;
            font-size: 28px;
            line-height: 1;
        }
    }

    .detail-project-name {
        color: #f0f7ff;
        font-size: 20px;
        font-weight: 500;
        text-align: center;
        line-height: 1.55;
        letter-spacing: 0;
        word-break: break-all;
    }

    .detail-card-left .level-pill {
        align-self: center;
    }

    /* 中栏：时间 + 时间轴 + 状态 */
    .detail-card-middle {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 30px;
        padding: 14px 0;
        flex: 1;
    }

    .detail-time {
        color: #d4e1f8;
        font-size: 16px;
        font-weight: 500;
        line-height: 2.38;
        text-align: center;
    }

    /* 时间轴：标签 + 线 + 节点 + 图片 + 节点 + 线 + 标签 */
    .detail-timeline {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 23px;
    }

    .timeline-label {
        color: #d4e1f8;
        font-size: 14px;
        font-weight: 500;
        line-height: 1;
        white-space: nowrap;
    }

    .timeline-line {
        width: 118.5px;
        height: 13px;
        flex-shrink: 0;
        vertical-align: middle;
    }

    .timeline-node {
        width: 24px;
        height: 48px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .timeline-node svg {
        width: 24px;
        height: 48px;
    }

    .timeline-img {
        width: 32px;
        height: 51px;
        border-radius: 3px;
        background: linear-gradient(135deg, rgba(0, 251, 255, 0.2), rgba(35, 88, 203, 0.35));
        border: 1px solid rgba(0, 251, 255, 0.4);
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .timeline-img img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    /* 状态 */
    .detail-status {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 4px;
    }

    .status-dot {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .status-dot svg {
        width: 16px;
        height: 16px;
    }

    .status-label {
        font-size: 16px;
        font-weight: 500;
        line-height: 1;
    }

    display: inline-block;
}

.status-label {
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
}

/* 右栏：预警接受人 */
.detail-card-right {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 24px 10px;
    width: 262px;
    flex-shrink: 0;
}

.detail-card-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
}

.section-bar {
    width: 6px;
    height: 19px;
    border-radius: 1px;
    background: #168dff;
    box-shadow: 0 0 10px 0 rgba(22, 141, 255, 0.45);
    flex-shrink: 0;
}

.detail-section-title>span:not(.section-bar) {
    color: #f0f7ff;
    font-size: 14px;
    font-weight: 500;
    line-height: 3.43;
}

.section-title-text {
    color: #f0f7ff;
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
}

.handler-list {
    display: flex;
    flex-direction: column;
    gap: 9px;
    max-height: 120px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
}

.handler-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
}

.handler-cell {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    flex: 0 0 calc(50% - 21.5px);
}

.handler-avatar {
    width: 23px;
    height: 22px;
    border-radius: 4px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.handler-name {
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
}

/* ==== 区块二 & 三：通用 section 样式 ==== */
.detail-section {
    margin-top: 20px;
    position: relative;
    background: rgba(0, 17, 74, 0.6);
    border: 2px solid rgba(10, 111, 200, 0.68);
    border-radius: 10px;
    box-shadow: inset 0 0 10px 0 rgba(12, 99, 197, 0.18);
    padding: 0 16px 20px;
    box-sizing: border-box;
}

.detail-section-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 7px;
    flex-shrink: 0;
}

.detail-section-handle {
    flex-shrink: 0;
}

.detail-section-warning {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

/* 区块二：处理内容 */
.detail-handle-body {
    display: flex;
    flex-direction: row;
    gap: 21px;
}

.detail-handle-col {
    display: flex;
    flex-direction: column;
    flex: 2;
}

.detail-handle-img-col {
    flex: 1;
}

.detail-handle-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid #113461;
    padding-bottom: 10px;
    padding-left: 20px;
    gap: 24px;
}

.detail-handle-img-col .detail-handle-row:first-child {
    border-bottom: none;
    padding-bottom: 10px;
}

.handle-label {
    color: #9cb1d2;
    font-size: 14px;
    width: 96px;
    flex-shrink: 0;
    line-height: 2.86;
}

.handle-value {
    color: #d4e1f8;
    font-size: 14px;
    flex: 1;
    min-width: 0;
    line-height: 2.86;
    word-break: break-all;
}

.handle-value-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: normal;
}

.img-placeholder {
    width: 140px;
    height: 100px;
    border-radius: 8px;
    background: rgba(7, 26, 60, 0.36);
    border: 1.5px dashed rgba(43, 89, 136, 0.58);
    display: flex;
    align-items: center;
    justify-content: center;
}

.img-placeholder-text {
    color: #798ba6;
    font-size: 13px;
    line-height: 1;
}

.img-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.handle-img {
    width: 140px;
    height: 100px;
    border-radius: 8px;
    object-fit: cover;
    border: 1px solid rgba(43, 89, 136, 0.58);
    cursor: pointer;
}

/* 区块三：预警内容 */
.detail-warning-body {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: 12px;
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.warning-dot {
    width: 18px;
    height: 18px;
    border-radius: 18px;
    background: #FD6969;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 0 8px 0 #FD6969;
    margin: 10px 0 0 10px;
}

.warning-dot-inner {
    width: 8px;
    height: 8px;
    border-radius: 8px;
    background: #FD6969;
    box-shadow: 0 0 4px 0 #FD6969;
    border: 2px solid rgba(7, 26, 60, 0.36);
}

.warning-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    height: 100%;
    gap: 0;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    padding-right: 4px;
    padding-bottom: 16px;
    box-sizing: border-box;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(96, 170, 255, 0.55);
        border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0.15);
        border-radius: 4px;
    }
}

.warning-time-text {
    color: #b8cbe8;
    font-size: 14px;
    font-weight: 500;
    line-height: 2.86;
}

.warning-text-card {
    position: relative;
    border: 2px solid rgba(228, 77, 84, 0.72);
    border-radius: 8px;
    background: rgba(46, 26, 51, 0.72);
    box-shadow: inset 0 0 10px 0 rgba(228, 77, 84, 0.18);
    padding: 16px 24px;
    box-sizing: border-box;
    min-height: 80px;
}

.warning-text {
    color: #d4e1f8;
    font-size: 14px;
    font-weight: 500;
    line-height: 2.86;
    white-space: pre-wrap;
    word-break: break-all;
}

.level-pill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    border-radius: 100px;
    font-size: 18px;
    font-weight: 600;
    line-height: 1;
    flex-shrink: 0;
    height: 36px;
    min-width: 64px;
    box-sizing: border-box;
}

.level-pill.level-1 {
    background: #c8e1ff;
    color: #1a6fd4;
}

.level-pill.level-2 {
    background: #fff2db;
    color: #cf911f;
}

.level-pill.level-3 {
    background: #fcedec;
    color: #f51f45;
}


/* 顶部标题胶囊 */
.title-pill {
    position: relative;
    width: 280px;
    height: 30px;
    margin: 4px auto 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    // background: linear-gradient(180deg, rgba(28, 118, 196, 0.95) 0%, rgba(20, 80, 148, 0.95) 100%);
    // border: 1px solid rgba(94, 180, 234, 0.55);
    // border-radius: 999px;
    // box-shadow:
    //   0 0 8px 0 rgba(94, 180, 234, 0.35),
    //   inset 0 0 8px 0 rgba(120, 200, 255, 0.4);
    background: url('~@/assets/titleBg.png') no-repeat center center;
    background-size: 100% 100%;
    overflow: hidden;
}

.title-pill::before,
.title-pill::after {
    content: "";
    position: absolute;
    top: 50%;
    width: 60px;
    height: 1px;
    background: linear-gradient(90deg, rgba(94, 180, 234, 0) 0%, rgba(94, 180, 234, 0.7) 50%, rgba(94, 180, 234, 0) 100%);
    transform: translateY(-50%);
}

.title-pill::before {
    left: -70px;
}

.title-pill::after {
    right: -70px;
}

.title-pill-text {
    font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: 6px;
    padding-left: 6px;
    text-shadow: 0 0 6px rgba(120, 200, 255, 0.6);
}
</style>


// WEBPACK FOOTER //
// src/components/warningDialog/warningDialog.vue